import type { DTOOf, IWebhook, PaginatedResponse, WebhookStatus } from '@atlas/types'
import { apiClient } from './api.client'

/** One ledger row as the API serializes it — dates are ISO strings. */
export type WebhookDTO = DTOOf<IWebhook>

export interface WebhookListParams {
	status?: WebhookStatus
	provider?: string
	/** Relative window, resolved to an instant server-side so clock skew cannot shift it. */
	sinceMinutes?: number
	page?: number
	limit?: number
}

/**
 * The SUPER_ADMIN webhook ledger.
 *
 * Read-and-retry only: nothing here creates or deletes a delivery. A ledger row is
 * a durable receipt, so its lifecycle is its `status`, never deletion.
 */
export const webhookApi = {
	listWebhooks: (params: WebhookListParams = {}): Promise<PaginatedResponse<WebhookDTO>> =>
		apiClient
			.get<PaginatedResponse<WebhookDTO>>('/admin/webhooks', {
				params: {
					...(params.status ? { 'filters[status]': params.status } : {}),
					...(params.provider ? { 'filters[provider]': params.provider } : {}),
					...(params.sinceMinutes ? { 'filters[sinceMinutes]': String(params.sinceMinutes) } : {}),
					...(params.page ? { page: params.page } : {}),
					...(params.limit ? { limit: params.limit } : {}),
				},
			})
			.then((r) => r.data),

	/** Re-queue a FAILED delivery. Rejected with 409 for any other status. */
	retryWebhook: (webhookId: string): Promise<void> =>
		apiClient.post(`/admin/webhooks/${webhookId}/retry`).then(() => undefined),
}
